import { Column } from '@synqo/frontend-component-library';
import { ApiCostCenter } from '@Model';

export const costCenterColumns: Column<ApiCostCenter>[] = [
    { name: 'shorthand', label: 'Suchcode' },
    { name: 'number', label: 'Nummer' },
    { name: 'label', label: 'Bezeichnung' },
];
